var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.5,
    height: 12,
    viewBox: "0 0 6.5 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_10413",
    "data-name": "\\uD328\\uC2A4 10413",
    d: "M8.1,15.665a.727.727,0,0,1-.562-.276.932.932,0,0,1,.043-1.211l4.362-4.513L7.581,5.152a.932.932,0,0,1-.043-1.211.708.708,0,0,1,1.081-.048l4.971,5.143a.929.929,0,0,1,0,1.26L8.618,15.438A.719.719,0,0,1,8.1,15.665Z",
    transform: "translate(-7.335 -3.665)",
    fill: "#212529"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListArrow);
export default __webpack_public_path__ + "static/media/ListArrow.430b649a26f3c8cd8e895cece4d32b49.svg";
export { ForwardRef as ReactComponent };